import BConfirm from './packages/BConfirm'

BConfirm.install = function (Vue) {
  Vue.component(BConfirm.name, BConfirm)
}

export default BConfirm
